import React, { useState, useRef } from 'react'
import PropTypes from 'prop-types'
import { v4 as uuid } from 'uuid'

// Mol
import Modal, { ModalSize } from '../../Modal'
import MServiceHomePartModal from '../../Modal/Part/MServiceHome'
import MSolicitarPartModal from '../../Modal/Part/MSolicitar'

function PlayPlanCardMol(props) {
	const {
		title,
		titlestyle,
		name,
		changeCompare,
		// fi_ID_TELEFONIA,
		// fi_ID_TELEVISION,
		// fi_ID_INTERNET,
		// fi_CATEGORIA,
		// fc_TIPO_DISPONIBILIDAD,
		// fc_TEXTO_CAJA,
		// fc_COLOR_CAJA,
		// fc_NOMBRE,
		fc_DESCRIPCION,
		fi_NUMERO_CARACTERISTICAS_MOSTRAR,
		fc_TITULO_CARACTERISTICAS_AGRUPADAS,
		fi_PRECIO_PLAN,
		// fi_PRECIO_TELEFONIA_ENPS,
		// fi_PRECIO_TELEVISION_ESPN,
		// fi_PRECIO_INTERNET_ESPS,
		// fc_COLOR_PRECIO,
		fc_ETIQUETA_PRECIO_TACHADO,
		fc_PRECIO_TACHADO,
		fc_NOTA_DEBAJO_PRECIO,
		fc_TEXTO_DETALLE,
		fc_URL_DETALLE,
		fc_TARGET_DETALLE,
		// fi_BAN_DETALLE,
		fc_OPCION_CONTRATACION,
		fc_TEXTO_CONTRATAR,
		fc_URL_CONTRATAR,
		fc_TARGET_CONTRATAR,
		// fi_BAN_CONTRATAR,
		// fi_ORDEN,
		// fi_ACTIVO,
		// fi_ID_DASHBOARD,
		// fi_BAN_ENPN,
		// fi_BAN_ENPS,
		// fi_BAN_ESPN,
		// fi_BAN_ESPS,
		// fc_ETIQUETA_PROMOCION_ATP,
		// fi_PRECIO_AHORRO,
		fc_ETIQUETA_PERIODO,
		Caracteristicas,
		Acordeon,
		lstPlanContratacionxPlan,
		filterPostPago,
	} = props
	let newAcordeon = Acordeon?.map((item, index) => {
		if (!item?.open) {
			item.open = false
		}
		return item;
	})
	const modalServiceRef = useRef()
	const modalRequestRef = useRef()
	const openModalService = () => modalServiceRef.current.open()
	const openModalRequest = () => modalRequestRef.current.open()

	const onClickSeeMore = () => {
		console.log('Conoce más')
		openModalService()
	}
	const onClickRequest = () => {
		console.log('Contratar')
		openModalRequest()
	}

	const searchCharacteristics = (search, TypeFlag = false, Caracteristicas, filterPostPago = null) => {
		if (TypeFlag) {
			const data = Caracteristicas?.length ? Caracteristicas : [];
			const newCaractData =  data/*data.filter(function (CaracData) {
				let CaracDESCRIPCION = [], idWS = 0

				CaracDESCRIPCION = CaracData.fc_DESCRIPCION
				idWS = CaracData.fi_CARACTERISTICA_WS.toString()
				let newCaracToShowTitle = postPagoCarac.find((element)=>{return element.fc_CARACTERISTICA_WS === idWS})

				console.log("to search---------- TypeFlag:", TypeFlag, search, filterPostPago, idWS, newCaracToShowTitle )
				if (filterPostPago){
					if (newCaracToShowTitle !== undefined){
						CaracData.fc_TITULO = newCaracToShowTitle.fc_TEXTO_MOSTRAR
					}
					return CaracDESCRIPCION.indexOf(search) > -1 && newCaracToShowTitle !== undefined
					// return CaracDESCRIPCION.indexOf(search) > -1
				}else{
					return CaracDESCRIPCION.indexOf(search) > -1
				}
			})*/
			// console.log("to search---------- TypeFlag:", TypeFlag, search, newCaractData, newCaractData.length)
			return newCaractData
		} else {
			const data = Caracteristicas?.length ? Caracteristicas : [];
			const newCaractData = data/*.filter(function (CaracData) {
				let CaracDESCRIPCION = [], idWS = 0

				CaracDESCRIPCION = CaracData.fc_DESCRIPCION
				idWS = CaracData.fi_CARACTERISTICA_WS.toString()
				let newCaracToShowTitle = postPagoCarac.find((element)=>{return element.fc_CARACTERISTICA_WS === idWS})

				console.log("to search---------- TypeFlag:", TypeFlag, search, filterPostPago, idWS, newCaracToShowTitle )
				if (filterPostPago){
					if (newCaracToShowTitle !== undefined){
						CaracData.fc_TITULO = newCaracToShowTitle.fc_TEXTO_MOSTRAR
					}
					return CaracDESCRIPCION.indexOf(search) === -1 && newCaracToShowTitle !== undefined
				}else{
					return CaracDESCRIPCION.indexOf(search) === -1
				}
			})*/
			// console.log("to search---------- TypeFlag:", TypeFlag, search, newCaractData, newCaractData.length)
			return newCaractData
		}
	}

	const [conditional, setConditional] = useState(false)

	let CharactBlock = searchCharacteristics('Tipo Footer', false, Caracteristicas, filterPostPago)
	let CharactFooter = searchCharacteristics('Tipo Footer', true, Caracteristicas, filterPostPago)

	// console.log("Characteristics: " + CharactBlock, CharactFooter, titlestyle)
	return (
		<>
			<div className={'cardPlan ' + (titlestyle ? titlestyle : 'amarillo')}>
				<div className="cardPlanTitle">
					<h3 className="cPlanTitleLabel">
						<strong>
							<span>
								{title}
							</span>
						</strong>
						<span>
							{name}
						</span>

					</h3>
					{
						fc_DESCRIPCION ?
							<p>
								{fc_DESCRIPCION}
							</p>
							: null
					}
				</div>
				{
					Caracteristicas ?
						<div className="cardPlanContent">
							{
								CharactBlock ?
									<div className="cPlanContBlock">
										{
											fc_TITULO_CARACTERISTICAS_AGRUPADAS ?
												<p className='cPlanTitleBlock '>
													{fc_TITULO_CARACTERISTICAS_AGRUPADAS}
												</p>
												: null
										}
										{
											CharactBlock.slice(0, fi_NUMERO_CARACTERISTICAS_MOSTRAR).map((caract, index) => (
												caract.fc_VALOR.includes("logo") ?
													<dl key={uuid()} className="cPlanDL">

														<dt>
															<span className={`${caract.fc_VALOR}`}></span>
														</dt>
														<dd>{caract.fc_TITULO}</dd>
													</dl>
													:
													<dl key={uuid()} className={`cPlanDL ${caract.fc_CLASE_ICONO ? 'iconEle' : ''}`}>

														{
															caract.fc_CLASE_ICONO
																?
																<dt>
																	<i className={caract.fc_CLASE_ICONO}></i>
																	<span>{caract.fc_TITULO}</span>
																</dt>
																:
																<dt>
																	{caract.fc_TITULO}
																</dt>
														}

														{
															caract.fc_DESCRIPCION.includes("Redes Sociales")
																?
																<dd className="cPlanRedS">
																	<ul>
																		{
																			caract.fc_VALOR.split("|").map((icoRed, index) => (
																				<li key={uuid()}>
																					<span>
																						<i className={icoRed} />
																					</span>
																				</li>
																			))
																		}
																	</ul>
																</dd>
																:
																<dd>{caract.fc_VALOR}</dd>
														}
													</dl>
											))
										}
									</div>
									: null
							}
							{
								CharactFooter ?
									CharactFooter.slice(0, fi_NUMERO_CARACTERISTICAS_MOSTRAR).map((caract, index) => (
										<div key={uuid()} className="cPlanIconBlock">
											<span className="iconCircle">
												{
													caract.fc_CLASE_ICONO ?
														<i className={caract.fc_CLASE_ICONO}></i>
														: null
												}

											</span>
											<p>
												<strong> {caract.fc_TITULO}</strong>
												<span> {caract.fc_VALOR}</span>
											</p>
										</div>
									))
									: null
							}

						</div>
						: null
				}
				{
					CharactBlock?.length > fi_NUMERO_CARACTERISTICAS_MOSTRAR ?
						<div className={`cardPlanContent cPlanViewMore ${conditional ? 'openDetails' : ''}`} >
							<span className="cPlanOpen" onClick={() => setConditional(c => !c)}> Ver m&aacute;s</span>
							<div className="cPlanContBlock">
								{

									CharactBlock.slice(fi_NUMERO_CARACTERISTICAS_MOSTRAR, Caracteristicas.length).map((caract, index) => (
										caract.fc_VALOR.includes("logo")
											?
											<dl key={uuid()} className="cPlanDL">

												<dt>
													<span className={`${caract.fc_VALOR}`}></span>
												</dt>
												<dd>{caract.fc_TITULO}</dd>
											</dl>
											:
											<dl key={uuid()} className={`cPlanDL ${caract.fc_CLASE_ICONO ? 'iconEle' : ''}`}>
												{
													caract.fc_CLASE_ICONO
														?
														<dt>
															<i className={caract.fc_CLASE_ICONO}></i>
															<span>{caract.fc_TITULO}</span>
														</dt>
														:
														<dt>
															{caract.fc_TITULO}
														</dt>
												}
												{
													caract.fc_DESCRIPCION.includes("Redes Sociales")
														?
														<dd className="cPlanRedS">
															<ul>
																{
																	caract.fc_VALOR.split("|").map((icoRed, index) => (
																		<li key={uuid()}>
																			<span>
																				<i className={icoRed} />
																			</span>
																		</li>
																	))
																}
															</ul>
														</dd>
														:
														<dd>{caract.fc_VALOR}</dd>
												}
											</dl>


									))
								}
							</div>

							<span className="cPlanClose" onClick={() => setConditional(c => !c)}>Ocultar</span>
						</div>
						: null
				}

				<div className="cardPlanPrice">
					{/* <p className='introText'>
					Precio Exclusivo Online
					<span>
						(Mensual x 1 año)
					</span>
				</p> */}
					{
						fc_ETIQUETA_PERIODO ?
							<p className='introText'>
								{fc_ETIQUETA_PERIODO}
							</p>
							: null
					}
					<div className="cPlanPriceBlock">
						<div className="cPlanCurrentPrice">
							{
								fi_PRECIO_PLAN ?
									<p>
										<span className="symbol"> $</span>
										<span className="cPrice">{fi_PRECIO_PLAN}</span>
										{/* <span className="sup"> .00</span> */}
									</p>
									: null
							}
						</div>
						{
							fc_ETIQUETA_PRECIO_TACHADO && fc_PRECIO_TACHADO ?
								<div className="cPlanPrevPrice">
									<p>{fc_ETIQUETA_PRECIO_TACHADO}: $ {fc_PRECIO_TACHADO}</p>
								</div>
								: null
						}
					</div>
					{
						fc_NOTA_DEBAJO_PRECIO ?
							<p className="leyend">
								{fc_NOTA_DEBAJO_PRECIO}
							</p>
							: null
					}
				</div>

				<div className="cardPlanActions">
					{
						fc_TEXTO_CONTRATAR ?
							fc_OPCION_CONTRATACION !== "LBX" ?
								<a className="btn btnPrimario" href={fc_URL_CONTRATAR} target={fc_TARGET_CONTRATAR ? fc_TARGET_CONTRATAR : '_self'}>
									{fc_TEXTO_CONTRATAR}
								</a>
								:
								<a className="btn btnPrimario" href="#!" onClick={() => onClickRequest()} target={fc_TARGET_CONTRATAR ? fc_TARGET_CONTRATAR : '_self'}>
									{fc_TEXTO_CONTRATAR}
								</a>
							: null
					}
					{
						changeCompare
							?
							<div className='cardPlanCompare'>
								{
									fc_TEXTO_DETALLE ?
										fc_URL_DETALLE !== "$URL_DEFAULT_DETALLE$"
											?
											<a className='textLink' href={fc_URL_DETALLE} target={fc_TARGET_DETALLE ? fc_TARGET_DETALLE : "_self"}>
												{fc_TEXTO_DETALLE}
											</a>
											:
											<a className='textLink' href="#!" target={fc_TARGET_DETALLE ? fc_TARGET_DETALLE : "_self"} onClick={() => onClickSeeMore()}>
												{fc_TEXTO_DETALLE}
											</a>
										: null
								}
							</div>
							:

							fc_TEXTO_DETALLE ?
								fc_URL_DETALLE !== "$URL_DEFAULT_DETALLE$"
									?
									<a className='textLink' href={fc_URL_DETALLE} target={fc_TARGET_DETALLE ? fc_TARGET_DETALLE : "_self"}>
										{fc_TEXTO_DETALLE}
									</a>
									:
									<a className='textLink' href="#!" target={fc_TARGET_DETALLE ? fc_TARGET_DETALLE : "_self"} onClick={() => onClickSeeMore()}>
										{fc_TEXTO_DETALLE}
									</a>
								: null

					}

				</div>
			</div>
			<Modal
				ref={modalServiceRef}
				// size={ModalSize.MEDIUM}
				size={ModalSize.MEDIUM_2}
			>
				<MServiceHomePartModal
					asks={newAcordeon}
					Caracteristicas={Caracteristicas}
					title={title}
					name={name}
					fc_DESCRIPCION={fc_DESCRIPCION}
					fi_PRECIO_PLAN={fi_PRECIO_PLAN}
					fc_ETIQUETA_PERIODO={fc_ETIQUETA_PERIODO}
					titlestyle={titlestyle}
				/>
			</Modal>
			<Modal
				ref={modalRequestRef}
				size={ModalSize.SMALL}
			>
				<MSolicitarPartModal
					title={title}
					name={name}
					fc_DESCRIPCION={fc_DESCRIPCION}
					fi_PRECIO_PLAN={fi_PRECIO_PLAN}
					fc_ETIQUETA_PERIODO={fc_ETIQUETA_PERIODO}
					lstPlanContratacionxPlan={lstPlanContratacionxPlan}
				/>
			</Modal>
		</>
	)
}

PlayPlanCardMol.defaultProps = {
	title: '3 Play',
	changeCompare: null,
}
PlayPlanCardMol.propTypes = {
	title: PropTypes.string,
	changeCompare: PropTypes.func
}
export default PlayPlanCardMol
